import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import Video from 'components/Video/VideoLoader';
import throttle from 'lodash.throttle';
import { inViewForReact, rodate } from 'utils/common';
import makeRequest from 'utils/makeRequest';
import Card from 'components_v2/common/CardV7/Card';
import Link from '../../../components/Link';
import { openVideoModal } from '../../mobile/VideoModal/redux';
import Listingheader from '../../../routes/home/components/common/Listingheader';
import s from './VideoSlider.scss';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';

class VideoSlider extends React.Component {
  constructor() {
    super();
    this.state = {
      leadVideoPlayInitiated: false,
      csrData: undefined,
    };
  }
  componentDidMount() {
    if (this.props.autoPlayLeadVideo) {
      this.throttledScrollEvent = throttle(this.playVideoInView, 100);
      window.addEventListener('scroll', this.throttledScrollEvent);
    }
  }
  handleVideoClick = (item, index) => {
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: `election_videos_insert`,
      category: 'story_click',
      label: item?.hl,
      story_no: `${index + 1}`,
      msid: item?.id,
    });
  };

  componentWillUnmount() {
    this.removeScrollEvent();
  }
  removeScrollEvent = () => {
    if (this.props.autoPlayLeadVideo) {
      window.removeEventListener('scroll', this.throttledScrollEvent);
    }
  };

  isElementEdgesVisible = el => {
    if (el && inViewForReact(el, 0, true)) {
      return true;
    }
    return false;
  };

  playVideoInView = () => {
    if (!this.videoElem) {
      const { sectionData } = this.props;
      const data = sectionData.data || sectionData.items;
      if (Array.isArray(data) && data.length && data[0] && data[0].id) {
        this.videoElem = document.querySelector(
          `[data-videomsid="${data[0].id}"]`,
        );
      }
    }

    if (this.videoElem && this.isElementEdgesVisible(this.videoElem)) {
      this.setState({ leadVideoPlayInitiated: true });
      window.removeEventListener('scroll', this.throttledScrollEvent);
    }
  };

  loadData = () => {
    const { sectionData } = this.props;
    if (sectionData && sectionData.dataUrl) {
      makeRequest
        .get(sectionData.dataUrl)
        .then(response => {
          if (
            response &&
            response.status === 200 &&
            response.data &&
            Array.isArray(response.data.items)
          ) {
            this.setState({
              csrData: response.data.items,
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  // Ga4 widget view call
  ga4ViewElement = (ga4Type, ga4Category) => {
    if (ga4Type) {
      analyticsWrapper('ga4', {
        event: 'user_shown',
        type: `${ga4Type}`,
        category: `${ga4Category || ''}`,
      });
    }
  };

  render() {
    const {
      sectionData,
      isClientSide,
      ga4Type,
      ga4Category,
      isFromSliderWrapper,
      Slider,
      settings,
      articleIndex,
    } = this.props;
    const data =
      (sectionData && (sectionData.data || sectionData.items)) ||
      this.state.csrData;

    if (!(Array.isArray(data) && data.length > 0)) {
      return null;
    }

    const videoItems = (
      <>
        {data.map((cardItem, index) => (
          <React.Fragment key={cardItem.id}>
            {index === 0 &&
            this.props.autoPlayLeadVideo &&
            this.state.leadVideoPlayInitiated ? (
              <>
                <figure
                  className={s.autoplaywrapper}
                  // onClick={event => {
                  //   this.handleVideoClick(event, cardItem, index);
                  // }}
                >
                  <Video
                    autoPlayLeadVideo={this.props.autoPlayLeadVideo}
                    msid={cardItem.id}
                    videoClassName={s.autoplayvdo}
                    videoClassInner={s.content}
                    autoplay
                    isInline
                    // hideControls
                    source={this.props.source || 'InlineVideoWidget'}
                    isMute
                    isVideoSkipAds={this.props.isVideoSkipAds}
                    tmplSource="articleshow"
                    videoInloop
                  />
                  <figcaption>
                    <Link to={cardItem.wu}>{cardItem.hl}</Link>
                  </figcaption>
                  {cardItem &&
                    cardItem.lpt && (
                      <div className={s.timestamp}>{rodate(cardItem.lpt)}</div>
                    )}
                </figure>
              </>
            ) : (
              <>
                <Card
                  data={{
                    ...cardItem,
                    lpt: cardItem && cardItem.lpt ? rodate(cardItem.lpt) : '',
                  }}
                  onClick={() => {
                    this.handleVideoClick(cardItem, index);
                  }}
                  layout="card_20"
                />
              </>
            )}
          </React.Fragment>
        ))}
      </>
    );
    if (isFromSliderWrapper && Slider && settings) {
      return (
        <div className={s.video_slide_wrap}>
          <div className="slick_UI smallArrow smallArrowBlack video_slider">
            {sectionData.name &&
              !this.props.isWapView && (
                <Listingheader
                  headingname={sectionData.name}
                  headingLink={sectionData.path}
                />
              )}
            <Slider {...settings}>
              {data.map((cardItem, index) => (
                <React.Fragment key={cardItem.id}>
                  {index === 0 &&
                  this.props.autoPlayLeadVideo &&
                  this.state.leadVideoPlayInitiated ? (
                    <figure
                      className={s.autoplaywrapper}
                      onClick={() => {
                        this.handleVideoClick(cardItem, index);
                      }}
                    >
                      <Video
                        autoPlayLeadVideo={this.props.autoPlayLeadVideo}
                        msid={cardItem.id}
                        videoClassName={s.autoplayvdo}
                        videoClassInner={s.content}
                        autoplay
                        // isInline
                        // hideControls
                        source={this.props.source || 'InlineVideoWidget'}
                        isMute
                        isVideoSkipAds={this.props.isVideoSkipAds}
                        tmplSource="articleshow"
                        videoInloop
                        overrideMsid={
                          articleIndex ? `${cardItem.id}_${articleIndex}` : ''
                        }
                      />
                      <figcaption>
                        <Link to={cardItem.wu}>{cardItem.hl}</Link>
                      </figcaption>
                      {cardItem &&
                        cardItem.lpt && (
                          <div className={s.timestamp}>
                            {rodate(cardItem.lpt)}
                          </div>
                        )}
                    </figure>
                  ) : (
                    <>
                      <Card
                        data={{
                          ...cardItem,
                          lpt:
                            cardItem && cardItem.lpt
                              ? rodate(cardItem.lpt)
                              : '',
                        }}
                        onClick={() => {
                          this.handleVideoClick(cardItem, index);
                        }}
                        layout="card_20"
                      />
                    </>
                  )}
                </React.Fragment>
              ))}
            </Slider>
          </div>
        </div>
      );
    }

    const component =
      data && data instanceof Array ? (
        <div className={s.widgetContainer}>
          <div className={`${s.videoWrapper}`}>
            {this.props.isWapView &&
              sectionData.name && (
                <div className={s.heading}>
                  {sectionData.path ? (
                    <Link to={sectionData.path}>{sectionData.name}</Link>
                  ) : (
                    <>{sectionData.name}</>
                  )}
                </div>
              )}

            <div className={s.video_items_wrap}>
              <div className={s.video_items}>{videoItems}</div>
            </div>
          </div>
        </div>
      ) : null;

    return isClientSide ? (
      <InViewObserver
        inViewCallback={() => {
          this.loadData();
          this.ga4ViewElement(ga4Type, ga4Category);
        }}
        viewMargin="900px 0px 900px 0px"
        id={sectionData && sectionData.jumplinkId}
      >
        {component}
      </InViewObserver>
    ) : (
      <InViewObserver
        inViewCallback={() => {
          this.ga4ViewElement(ga4Type, ga4Category);
        }}
        id={sectionData && sectionData.jumplinkId}
      >
        {component}
      </InViewObserver>
    );
  }
}

VideoSlider.propTypes = {
  sectionData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    path: PropTypes.string,
    data: PropTypes.shape({}),
    items: PropTypes.shape({}),
    dataUrl: PropTypes.string,
    className: PropTypes.string,
    tn: PropTypes.string,
  }).isRequired,
  openVideoModalFromProps: PropTypes.func.isRequired,
  theme: PropTypes.string,
  autoPlayLeadVideo: PropTypes.bool,
  source: PropTypes.string,
  gaAction: PropTypes.string,
  gaLabel: PropTypes.string,
  gaCategory: PropTypes.string,
  useContentVisibilty: PropTypes.bool,
  openVideoLink: PropTypes.bool,
  isClientSide: PropTypes.bool,
  fromEtimesAS: PropTypes.bool,
  gaLabelPrefix: PropTypes.string,
  gaLabelSuffix: PropTypes.string,
  useImageV2: PropTypes.bool,
  isVideoSkipAds: PropTypes.bool,
  gaFunction: PropTypes.func,
  ga4Type: PropTypes.string,
  ga4Category: PropTypes.string,

  isFromSliderWrapper: PropTypes.bool,
};
VideoSlider.defaultProps = {
  theme: '',
  autoPlayLeadVideo: false,
  source: '',
  gaAction: '',
  gaLabel: undefined,
  gaCategory: undefined,
  useContentVisibilty: false,
  openVideoLink: false,
  isClientSide: false,
  fromEtimesAS: false,
  gaLabelPrefix: '',
  gaLabelSuffix: '',
  useImageV2: false,
  isVideoSkipAds: false,
  gaFunction: undefined,
  ga4Type: '',
  ga4Category: '',

  isFromSliderWrapper: false,
};

const mapDispatchToProps = dispatch => ({
  openVideoModalFromProps: params => {
    dispatch(openVideoModal(params));
  },
});
export default connect(undefined, mapDispatchToProps)(VideoSlider);
